import script from "./castOrDirectorList.vue?vue&type=script&lang=ts&setup=true"
export * from "./castOrDirectorList.vue?vue&type=script&lang=ts&setup=true"

import "./castOrDirectorList.vue?vue&type=style&index=0&id=6f7eef42&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f7eef42"]])

export default __exports__